var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "xmlns:sketch": "http://www.bohemiancoding.com/sketch/ns",
        width: "800px",
        height: "800px",
        viewBox: "0 0 32 32",
        version: "1.1",
      },
    },
    [
      _c("title", [_vm._v("expand")]),
      _c("desc", [_vm._v("Created with Sketch Beta.")]),
      _c("defs"),
      _c(
        "g",
        {
          attrs: {
            id: "Page-1",
            stroke: "none",
            "stroke-width": "1",
            fill: "none",
            "fill-rule": "evenodd",
            "sketch:type": "MSPage",
          },
        },
        [
          _c(
            "g",
            {
              attrs: {
                id: "Icon-Set-Filled",
                "sketch:type": "MSLayerGroup",
                transform: "translate(-310.000000, -1193.000000)",
                fill: "#000000",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M341.977,1194.15 C341.976,1193.84 341.836,1193.56 341.623,1193.37 C341.43,1193.16 341.158,1193.01 340.849,1193.01 L332.079,1193 C331.499,1193 331.029,1193.47 331.029,1194.06 C331.03,1194.64 331.708,1195.3 331.998,1195.59 L334.216,1197.82 L328,1204 L331,1207 L337.174,1200.8 L339.392,1203.03 C339.871,1203.52 340.358,1204.03 340.938,1204.03 C341.52,1204.03 341.989,1203.56 341.988,1202.97 L341.977,1194.15 L341.977,1194.15 Z M321,1211 L314.746,1217.38 L312.565,1215.2 C312.094,1214.73 311.614,1214.22 311.044,1214.22 C310.473,1214.22 310.011,1214.68 310.012,1215.25 L310.023,1223.88 C310.023,1224.18 310.161,1224.45 310.371,1224.64 C310.561,1224.85 310.828,1224.99 311.132,1224.99 L319.756,1225 C320.326,1225 320.788,1224.54 320.788,1223.97 C320.787,1223.4 320.121,1222.75 319.835,1222.47 L317.654,1220.29 L324,1214 L321,1211 L321,1211 Z",
                  id: "expand",
                  "sketch:type": "MSShapeGroup",
                },
              }),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }